import $ from 'jquery';

const toggleSelectBox = (evt, options) => {
    const $select = $(evt.currentTarget);
    const $selectOptions = $(options.selectors.selectOptions);
    const target = $selectOptions.outerHeight();
    const bottom = $select[0].getBoundingClientRect().bottom;
    const spaceBelow = window.innerHeight - bottom;

    $select.toggleClass(options.modifiers.open);

    if (spaceBelow < target) {
        $selectOptions[0].scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

};

const onSelectOption = (evt, options) => {
    const $option = $(evt.currentTarget);

    if (!$option.hasClass(options.modifiers.selected)) {
        $option.parent().find('.' + options.modifiers.selected).removeClass(options.modifiers.selected);
        $option.addClass(options.modifiers.selected);
        $option.closest(options.selectors.select).find(options.selectors.selected).html($option.html());

        const params = {
            url: options.props.url,
            type: 'POST',
            data: {
                language: options.props.language,
                productCode: options.props.productCode,
                color: $option.data('value').toString()
            }
        };

        const $ajaxProductVariantsCard = $('#ajax-product-variants-card');

        $ajaxProductVariantsCard.addClass('loading');

        $.ajax(params)
            .then((res) => {
                $ajaxProductVariantsCard.html(res);
                if (window.app.stockLoader) window.app.stockLoader.init();
                $('.js-product-row-image').attr('src', $('.js-default-product-image').data('src'));
                window.app.refreshTotalPriceOnChangeVariant();
            })
            .fail((error) => {
                console.error(error);
            })
            .always(() => {
                $ajaxProductVariantsCard.removeClass('loading');
            });
    }
};

const init = (selectorScope = '', opts) => {
    if (!selectorScope) {
        console.warn('Component triggered without scope');
        return;
    }

    const scope = selectorScope;

    const $scope = $(scope);
    if (!$scope.length) {
        return;
    }

    const defaults = {
        selectors: {
            select: '.js-color-selectbox',
            selectOption: '.js-color-selectbox-option',
            selectOptions: '.js-color-selectbox-options',
            selected: '.js-color-selectbox-selected'
        },
        modifiers: {
            open: 'is-open',
            selected: 'is-selected'
        },
        props: {
            url: $scope.data('url'),
            language: $scope.data('language'),
            productCode: $scope.data('productcode')
        }

    };

    const options = $.extend(true, defaults, opts);

    const $select = $(options.selectors.select);

    $scope.on('click', options.selectors.select, (evt) => toggleSelectBox(evt, options));

    $scope.on('click', options.selectors.selectOption, (evt) => onSelectOption(evt, options));

    $(document).on('click', (evt) => {
        if ($(evt.target).closest($select).length === 0) {
            $select.removeClass(options.modifiers.open);
        }
    });
};

export default {
    init
};
